import {
	SET_CURRENT_DASHBOARD_ID,
	RESET_CURRENT_DASHBOARD_ID
} from "../../actions/DashboardDesigner/actionContants";

const currentDashboardId = (state = null, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_CURRENT_DASHBOARD_ID:
			return payload;
		case RESET_CURRENT_DASHBOARD_ID:
			return null;
		default:
			return state;
	}
};

export default currentDashboardId;
